import { Link } from 'react-router-dom';
import SEOHead from '../../components/base/SEOHead';
import Header from '../../components/feature/Header';

export default function Blog() {
  const blogSchema = [
    {
      "@context": "https://schema.org",
      "@type": "Blog",
      "name": "おかやま警備株式会社ブログ",
      "description": "交通誘導警備に関する情報や最新のお知らせをお届けします",
      "url": "SITE_URL_PLACEHOLDER/blog",
      "publisher": {
        "@type": "Organization",
        "name": "おかやま警備株式会社"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "ホーム",
          "item": "SITE_URL_PLACEHOLDER/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "ブログ・新着情報",
          "item": "SITE_URL_PLACEHOLDER/blog"
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="ブログ・新着情報｜おかやま警備株式会社｜倉敷市の交通誘導警備"
        description="おかやま警備株式会社のブログ・新着情報。交通誘導警備に関する情報、倉敷市内でのイベント警備実績、安全対策、研修制度、資格取得情報など、警備業務に関する最新情報をお届けします。"
        keywords="ブログ,新着情報,お知らせ,交通誘導警備,倉敷市,警備業務,安全対策,研修"
        canonical="/blog"
        schema={blogSchema}
      />
      <Header />

      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center bg-cover bg-center" style={{backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/b0d60d6b29db2bac98e6d5b81adc01c6.jpg')`}}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">ブログ・新着情報</h1>
          <p className="text-xl md:text-2xl text-white">おかやま警備の最新情報をお届けします</p>
        </div>
      </section>

      {/* Latest News */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">新着情報</h2>
            <p className="text-xl text-gray-600">最新のお知らせ</p>
          </div>
          <div className="space-y-6">
            <div className="bg-gray-50 p-6 rounded-xl hover:shadow-lg transition-shadow cursor-pointer">
              <div className="flex items-start gap-6">
                <div className="flex-shrink-0">
                  <div className="bg-blue-900 text-white px-4 py-2 rounded-lg text-center">
                    <div className="text-2xl font-bold">15</div>
                    <div className="text-xs">2025.01</div>
                  </div>
                </div>
                <div className="flex-1">
                  <div className="inline-block bg-red-100 text-red-800 px-3 py-1 rounded-full text-xs font-semibold mb-2">重要</div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">年末年始の営業時間のお知らせ</h3>
                  <p className="text-gray-700 leading-relaxed">誠に勝手ながら、2025年12月29日（日）から2026年1月3日（金）まで年末年始休業とさせていただきます。1月4日（土）より通常営業いたします。緊急のご依頼につきましては、お問い合わせフォームよりご連絡ください。</p>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-xl hover:shadow-lg transition-shadow cursor-pointer">
              <div className="flex items-start gap-6">
                <div className="flex-shrink-0">
                  <div className="bg-blue-900 text-white px-4 py-2 rounded-lg text-center">
                    <div className="text-2xl font-bold">10</div>
                    <div className="text-xs">2025.01</div>
                  </div>
                </div>
                <div className="flex-1">
                  <div className="inline-block bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-semibold mb-2">お知らせ</div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">倉敷市内の大規模イベント警備を実施しました</h3>
                  <p className="text-gray-700 leading-relaxed">1月8日（月）に倉敷市内で開催された新春イベントにて、駐車場誘導と交通整理を担当させていただきました。約5,000名の来場者がありましたが、大きなトラブルもなく無事に終了いたしました。ご依頼いただきました主催者様、ありがとうございました。</p>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-xl hover:shadow-lg transition-shadow cursor-pointer">
              <div className="flex items-start gap-6">
                <div className="flex-shrink-0">
                  <div className="bg-blue-900 text-white px-4 py-2 rounded-lg text-center">
                    <div className="text-2xl font-bold">05</div>
                    <div className="text-xs">2025.01</div>
                  </div>
                </div>
                <div className="flex-1">
                  <div className="inline-block bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs font-semibold mb-2">採用情報</div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">交通誘導警備スタッフを募集中です</h3>
                  <p className="text-gray-700 leading-relaxed">倉敷市を中心に活動する交通誘導警備スタッフを募集しています。未経験者も大歓迎です。丁寧な研修制度があり、先輩スタッフがしっかりサポートします。週2日からの勤務も可能です。詳しくは求人情報ページをご覧ください。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Blog Posts */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">ブログ記事</h2>
            <p className="text-xl text-gray-600">警備業務に関する情報をお届けします</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <article className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow cursor-pointer">
              <img src="https://readdy.ai/api/search-image?query=Japanese%20security%20guard%20in%20professional%20uniform%20demonstrating%20proper%20traffic%20control%20hand%20signals%20at%20training%20session%2C%20educational%20setting%2C%20clear%20instructional%20photography%2C%20realistic%20high%20quality%20image&width=600&height=400&seq=blog001&orientation=landscape" alt="交通誘導の基本" className="w-full h-48 object-cover object-top" />
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <span className="bg-blue-100 text-blue-900 px-3 py-1 rounded-full text-xs font-semibold">業務紹介</span>
                  <span className="text-sm text-gray-500">2024.12.20</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">交通誘導警備の基本と重要性</h3>
                <p className="text-gray-700 leading-relaxed mb-4">交通誘導警備は、工事現場やイベント会場などで車両や歩行者を安全に誘導する重要な業務です。倉敷市内でも多くの現場で交通誘導警備が必要とされています。本記事では、交通誘導警備の基本的な役割と、安全確保のために必要なスキルについて解説します。</p>
                <div className="flex items-center text-blue-900 font-semibold hover:text-blue-700">
                  続きを読む <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </div>
            </article>

            <article className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow cursor-pointer">
              <img src="https://readdy.ai/api/search-image?query=Japanese%20security%20personnel%20wearing%20complete%20safety%20equipment%20including%20helmet%20vest%20and%20gloves%20at%20construction%20site%2C%20professional%20safety%20gear%20display%2C%20educational%20photography%2C%20realistic%20high%20quality&width=600&height=400&seq=blog002&orientation=landscape" alt="安全装備の重要性" className="w-full h-48 object-cover object-top" />
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-semibold">安全対策</span>
                  <span className="text-sm text-gray-500">2024.12.15</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">警備員の安全装備について</h3>
                <p className="text-gray-700 leading-relaxed mb-4">交通誘導警備において、警備員自身の安全確保は最優先事項です。反射ベスト、ヘルメット、誘導灯など、適切な安全装備の着用が義務付けられています。倉敷市内の現場でも、これらの装備を正しく使用することで、事故を未然に防いでいます。</p>
                <div className="flex items-center text-blue-900 font-semibold hover:text-blue-700">
                  続きを読む <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </div>
            </article>

            <article className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow cursor-pointer">
              <img src="https://readdy.ai/api/search-image?query=Japanese%20security%20team%20conducting%20safety%20training%20session%20indoors%2C%20professional%20training%20environment%2C%20instructor%20teaching%20group%20of%20trainees%2C%20educational%20setting%2C%20realistic%20photography&width=600&height=400&seq=blog003&orientation=landscape" alt="研修制度" className="w-full h-48 object-cover object-top" />
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-xs font-semibold">教育・研修</span>
                  <span className="text-sm text-gray-500">2024.12.10</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">新人警備員の研修プログラム</h3>
                <p className="text-gray-700 leading-relaxed mb-4">おかやま警備では、未経験者でも安心して働けるよう、充実した研修プログラムを用意しています。座学での基礎知識習得から、実地訓練まで、段階的に学べる環境を整えています。倉敷市内の現場で活躍できる警備員を育成しています。</p>
                <div className="flex items-center text-blue-900 font-semibold hover:text-blue-700">
                  続きを読む <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </div>
            </article>

            <article className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow cursor-pointer">
              <img src="https://readdy.ai/api/search-image?query=Japanese%20security%20guard%20managing%20traffic%20at%20summer%20festival%20with%20many%20visitors%2C%20crowded%20event%20scene%2C%20professional%20event%20security%20work%2C%20daytime%20festive%20atmosphere%2C%20realistic%20photography&width=600&height=400&seq=blog004&orientation=landscape" alt="夏季イベント警備" className="w-full h-48 object-cover object-top" />
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <span className="bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-xs font-semibold">現場レポート</span>
                  <span className="text-sm text-gray-500">2024.12.05</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">倉敷市夏祭りでの警備活動報告</h3>
                <p className="text-gray-700 leading-relaxed mb-4">2024年夏に開催された倉敷市の大規模な夏祭りにて、駐車場誘導と交通整理を担当しました。約10,000名の来場者があり、混雑が予想されましたが、事前の綿密な計画と当日の柔軟な対応により、スムーズな運営をサポートできました。</p>
                <div className="flex items-center text-blue-900 font-semibold hover:text-blue-700">
                  続きを読む <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </div>
            </article>

            <article className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow cursor-pointer">
              <img src="https://readdy.ai/api/search-image?query=Japanese%20security%20personnel%20directing%20traffic%20in%20heavy%20rain%20with%20proper%20rain%20gear%20and%20safety%20equipment%2C%20challenging%20weather%20conditions%2C%20professional%20dedication%2C%20realistic%20photography&width=600&height=400&seq=blog005&orientation=landscape" alt="悪天候時の対応" className="w-full h-48 object-cover object-top" />
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <span className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-xs font-semibold">安全管理</span>
                  <span className="text-sm text-gray-500">2024.11.28</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">悪天候時の交通誘導のポイント</h3>
                <p className="text-gray-700 leading-relaxed mb-4">雨天や強風時の交通誘導は、通常時以上に注意が必要です。視界の悪化や路面の滑りやすさなど、様々なリスクが高まります。倉敷市内の現場でも、天候に応じた適切な対応を心がけています。悪天候時の安全対策について詳しく解説します。</p>
                <div className="flex items-center text-blue-900 font-semibold hover:text-blue-700">
                  続きを読む <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </div>
            </article>

            <article className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow cursor-pointer">
              <img src="https://readdy.ai/api/search-image?query=Japanese%20security%20guard%20showing%20professional%20certification%20document%20with%20proud%20smile%2C%20office%20background%2C%20achievement%20concept%2C%20professional%20photography%2C%20realistic%20high%20quality&width=600&height=400&seq=blog006&orientation=landscape" alt="資格取得" className="w-full h-48 object-cover object-top" />
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <span className="bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-xs font-semibold">キャリア</span>
                  <span className="text-sm text-gray-500">2024.11.20</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">交通誘導警備業務検定について</h3>
                <p className="text-gray-700 leading-relaxed mb-4">交通誘導警備業務検定は、警備員のスキルを証明する国家資格です。1級と2級があり、取得することで専門性が認められ、キャリアアップにもつながります。おかやま警備では、資格取得を全面的にサポートしています。</p>
                <div className="flex items-center text-blue-900 font-semibold hover:text-blue-700">
                  続きを読む <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-blue-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">お問い合わせ</h2>
          <p className="text-xl text-blue-100 mb-8">交通誘導警備のご依頼・ご相談はお気軽にどうぞ</p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a href="tel:086-012-3456" className="bg-white text-blue-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 whitespace-nowrap cursor-pointer inline-flex items-center justify-center">
              <i className="ri-phone-fill mr-2"></i>086-012-3456
            </a>
            <Link to="/#contact" className="bg-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-600 whitespace-nowrap cursor-pointer inline-flex items-center justify-center">
              <i className="ri-mail-fill mr-2"></i>お問い合わせフォーム
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            <div>
              <h3 className="text-xl font-bold mb-4">おかやま警備株式会社</h3>
              <p className="text-gray-400 text-sm leading-relaxed">倉敷市を中心に、確かな技術と丁寧な対応で地域の安全を守ります。</p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">サービス</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/services" className="text-gray-400 hover:text-white cursor-pointer">道路工事現場の交通誘導</Link></li>
                <li><Link to="/services" className="text-gray-400 hover:text-white cursor-pointer">建設現場の警備</Link></li>
                <li><Link to="/services" className="text-gray-400 hover:text-white cursor-pointer">イベント会場の交通整理</Link></li>
                <li><Link to="/services" className="text-gray-400 hover:text-white cursor-pointer">商業施設の駐車場警備</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">会社情報</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/company" className="text-gray-400 hover:text-white cursor-pointer">会社概要</Link></li>
                <li><Link to="/recruit" className="text-gray-400 hover:text-white cursor-pointer">求人情報</Link></li>
                <li><Link to="/blog" className="text-gray-400 hover:text-white cursor-pointer">ブログ・新着情報</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">お問い合わせ</h4>
              <ul className="space-y-2 text-sm">
                <li className="flex items-start">
                  <i className="ri-phone-fill mr-2 mt-1"></i>
                  <a href="tel:086-012-3456" className="text-gray-400 hover:text-white cursor-pointer">086-012-3456</a>
                </li>
                <li className="flex items-start">
                  <i className="ri-printer-fill mr-2 mt-1"></i>
                  <span className="text-gray-400">086-012-3457</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-map-pin-fill mr-2 mt-1"></i>
                  <span className="text-gray-400">岡山市北区○○町1-2-3</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">&copy; 2025 おかやま警備株式会社. All rights reserved.</p>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-sm mt-4 md:mt-0 cursor-pointer">Powered by Readdy</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
